import type React from 'react'

import {useAppDispatch, useAppSelector} from '../../../../../../../../../hooks/react-redux'
import {
  getJobCheckoutWorkingDirectoriesOnly,
  getOriginalPipelineSettings,
} from '../../../../../../EditPipelinePage/EditPipelinePage.selectors'
import {pipelineDraft} from '../../../../../../EditPipelinePage/slices/EditPipelinePage.slices'
import {usePipelineId} from '../../../../../../hooks/pipeline'

function useJobCheckoutWorkingDirectoriesOnly(jobId: string) {
  const dispatch = useAppDispatch()
  const pipelineId = usePipelineId()
  const sevedCheckoutWorkingDirectoriesOnly = useAppSelector(
    getOriginalPipelineSettings(pipelineId),
  )?.jobs?.[jobId]?.['checkout-working-directories-only']
  const jobCheckoutWorkingDirectoriesOnly = useAppSelector(
    getJobCheckoutWorkingDirectoriesOnly(jobId, pipelineId),
  )
  const isCheckoutWorkingDirectoriesOnly = jobCheckoutWorkingDirectoriesOnly === undefined
  const handlerCheckoutWorkingDirectoriesOnlyToggle = ({
    currentTarget,
  }: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      pipelineDraft.actions.toggleCheckoutWorkingDirectoriesOnly({
        id: pipelineId,
        jobId,
        value: currentTarget.checked,
      }),
    )
  }
  const isUnsaved = sevedCheckoutWorkingDirectoriesOnly !== jobCheckoutWorkingDirectoriesOnly

  return {
    handlerCheckoutWorkingDirectoriesOnlyToggle,
    isCheckoutWorkingDirectoriesOnly,
    isUnsaved,
  }
}

export default useJobCheckoutWorkingDirectoriesOnly
